<template>
  <div class="title">
    <span>{{ title }}</span>
  </div>
  <div class="col  field style-04">
    <div class="row" v-for="(item, index) in internalData" :key="index" :class="{add : index != 0}">
      <div class="field-one input-text-1 link-box">
        <input type="text" v-model="item.interviewLink" maxlength="999" :placeholder="placeholder">
      </div>
      <transition name="fade">
        <div v-show="item.interviewLink" class="field-one input-text-1 no-line title-box">
          <input type="text" v-model="item.interviewTitle" maxlength="999" placeholder="인터뷰 제목을 넣어주세요.">
        </div>
      </transition>
      <button v-if="index === internalData.length - 1" type="button" class="add-list add" @click="addListItem(item.type, item.typeLabel)">
        <img src="@/assets/images/icon/ico_add_c.png" alt="">
      </button>
      <button type="button" class="add-list delete" @click="removeItem(item.type, index)">
        <img src="@/assets/images/icon/ico_minus_c.png" alt="">
      </button>
    </div>
  </div>
</template>

<script setup>
import {reactive, toRefs, watch} from 'vue'
import {apiClient} from "@/services/auth-header";

const props = defineProps({
  title: String,
  placeholder: String,
  data: Array,
});
const {title, placeholder, data} = toRefs(props);
// props.data를 reactive 형태로 변환한 내부 데이터
const internalData = reactive(
    (props.data && props.data.length > 0) // props.data가 유효한 경우
        ? props.data.map((item) => ({
          id: item.id,
          interviewLink: item.interviewLink,
          interviewTitle: item.interviewTitle,
        }))
        : [{id:0, interviewLink: '', interviewTitle: ''}] // props.data가 없거나 빈 배열인 경우 기본값 추가
);

const maxItems = 3;
const addListItem = () => {
  if (internalData.length >= maxItems) {
    alert(`최대 ${maxItems}개까지 등록 가능합니다`);
    return;
  }
  internalData.push({id:0, interviewLink: '', interviewTitle: ''});
};
const removeItem = (type, index) => {
  internalData.splice(index, 1);

  // 데이터가 비어 있으면 기본값 추가
  if (internalData.length === 0) {
    addListItem();
  }
};

const getData = () => {
  return Array.from(internalData)
  .filter((item) => item.interviewLink) // interviewLink가 있는 항목만 필터링
  .map((item) => ({
    id: item.id,
    interviewLink: item.interviewLink,
    interviewTitle: item.interviewTitle,
  }));
};

defineExpose({
  getData
});
</script>

<style scoped>
.title-box {
  flex: 7;
}

.link-box {
  flex: 3;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

</style>